var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c("ul", { staticClass: "nav" }, [
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "nav-link header-logo",
              attrs: { to: { name: "home" } },
            },
            [_c("a", [_c("span", [_vm._v("Keykhosrow")])])]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav" }, [
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "nav-link header-index",
              attrs: { to: { name: "home" } },
            },
            [_c("a", [_c("span", [_vm._v("home")])])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { staticClass: "nav-link", attrs: { to: { name: "topic" } } },
            [_c("a", [_c("span", [_vm._v("Topic")])])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { staticClass: "nav-link", attrs: { to: { name: "support" } } },
            [_c("a", [_c("span", [_vm._v("Support")])])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { staticClass: "nav-link", attrs: { to: { name: "contact" } } },
            [_c("a", [_c("span", [_vm._v("Contact")])])]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }